<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div
    class="govuk-error-summary"
    aria-labelledby="error-summary-title"
    role="alert"
    data-module="govuk-error-summary"
  >
    <h2 id="error-summary-title" class="govuk-error-summary__title">
      {{ t('zoppm.zhrnutie.errors.title') }}
    </h2>
    <div class="govuk-error-summary__body">
      {{ t('zoppm.zhrnutie.errors.message') }}
    </div>
  </div>
</template>
